export const MAX_GET_AUTH_USERS = 100;

export type AuthUserProviderData = {
  uid: string;
  displayName?: string;
  email?: string;
  photoURL?: string;
  providerId: string;
  phoneNumber?: string;
};

export type AuthUserMetadata = {
  creationTime: string;
  lastSignInTime: string;
  lastRefreshTime?: string | null;
};

export type AuthUser = {
  uid: string;
  email?: string;
  emailVerified: boolean;
  displayName?: string;
  photoURL?: string;
  phoneNumber?: string;
  disabled: boolean;
  metadata: AuthUserMetadata;
  providerData: AuthUserProviderData[];
};

export type GetAuthUsersRequest = {
  accountId: string;
  eventId: string;
  uids: string[];
};

export type GetAuthUsersResponse = {
  users: AuthUser[];
};
